/* eslint-disable @nx/enforce-module-boundaries */
import { Button, Card, HStack, Spinner, Stack, Text } from '@mybridge/ui';
import { useRouter } from 'next/router';
import { forwardRef, useContext, useEffect, useState } from 'react';
import { AppliedJobCard } from 'v4/components/jobs/applied-job-card';
import { JobsNotFoundIllustration } from '../404';
import { JobsListingContext } from '../context';
import { AppliedJobsNotFoundIll } from '../404/applied-jobs';
import { isMobile } from 'react-device-detect';
import { useTranslator } from '@mybridge/ui/custom-hooks/useTranslation';

export const AppliedJobsListing = forwardRef(({ ...props }, ref) => {
  const {
    appliedJobsListing,
    refetchAppliedJobsListing,
    appliedJobsListingHasNextPage,
    fetchAppliedJobsListingNextPage,
    appliedJobsListingIsFetching,
    appliedJobsListingIsLoading,
    removeSavedJob,
    removeSavedJobIsLoading,
    isSavedJob,
    saveJob,
    saveJobIsLoading,
  } = useContext(JobsListingContext);
  const { push } = useRouter();
  const { t } = useTranslator();

  // useEffect(() => {
  //   refetchAppliedJobsListing?.();
  // }, []);
  const [selected, setSelected] = useState();
  if (appliedJobsListingIsLoading)
    return (
      <HStack justifyContent="center" py={12}>
        <Spinner />
      </HStack>
    );

  return (
    <Stack>
      {appliedJobsListing?.length > 0 ? (
        <Stack>
          <HStack alignItems="stretch" spacing={0} flexWrap="wrap" gap={5} marginBottom="100px">
            {appliedJobsListing?.map((job, jobIndex) => (
              <Card
                h={!isMobile?"290px":"auto"}
                w={['100%', '100%', '48.2%']}
                jobIndex={jobIndex}
                p={4}
                key={jobIndex}
                border="1px solid #D9D9D9"
                borderRadius="20px"
                //boxShadow="none"
                boxShadow="md"
              >
                <AppliedJobCard
                  href={'/jobs/' + job?.job_details?.id}
                  isSaved={
                    selected?.id === job?.id
                      ? !isSavedJob(job?.job_details?.id)
                      : isSavedJob(job?.job_details?.id)
                  }
                  onSaveClick={async () => {
                    const jobId = job?.job_details?.id;
                    const isCurrentlySaved = isSavedJob(jobId);

                    setSelected(job);

                    if (isCurrentlySaved) {
                      await removeSavedJob({ job_id: jobId });
                    } else {
                      await saveJob({ job_id: jobId });
                    }

                    setSelected(null);
                  }}
                  saveLoading={
                    selected?.id === job?.id &&
                    (saveJobIsLoading || removeSavedJobIsLoading)
                  }
                  onViewDetailsClick={(e) => {
                    push('/jobs/' + job?.job_details?.id);
                  }}
                  job={job}
                />
              </Card>
            ))}
          </HStack>
          {/* {appliedJobsListingHasNextPage ? (
            <Button
              isLoading={appliedJobsListingIsFetching}
              onClick={fetchAppliedJobsListingNextPage}
              variant="secondary"
              ml={isMobile ? '6%' : ''}
            >
              Load More
            </Button>
          ) : (
            ''
          )} */}
        </Stack>
      ) : (
        <Stack alignItems="center" justifyContent="center" py="12">
          <AppliedJobsNotFoundIll />
          <Text>{t('jobs.noAppliedJobs') || "You have not applied to any jobs yet."}</Text>
        </Stack>
      )}
    </Stack>
  );
});
